import isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import styled from 'styled-components';
import {
  ISelectableEntity,
  ISelectOption,
  ITest,
  ITestType,
} from '../../../data/types';
import { roundValue } from '../../../utils/math';
import { ListAvatar } from '../../shared/List/ListAvatar';
import { ListItem, ListItemCell } from '../../shared/List/ListItem';
import { Metric } from '../../shared/Metric';

const ordinalSuffix = (i: number): string => {
  const j = i % 10;
  const k = i % 100;
  if (j === 1 && k !== 11) {
    return i + 'st';
  }
  if (j === 2 && k !== 12) {
    return i + 'nd';
  }
  if (j === 3 && k !== 13) {
    return i + 'rd';
  }
  return i + 'th';
};

interface IProps {
  test: ITest;
  metric: ISelectOption;
  testType: ISelectableEntity;
  index: number;
  goToTest: (athleteId: string, testId: string) => void;
  style?: React.CSSProperties;
}

export const ScoreboardItem = (props: IProps): React.ReactElement => {
  const clickHandler = (): void =>
    props.goToTest(props.test.athleteId, props.test.id);

  return (
    <ListItem style={props.style} onClick={clickHandler}>
      <ListItemCell>
        <OrdinalContainer>
          <h1>{ordinalSuffix(props.index + 1)}</h1>
        </OrdinalContainer>
      </ListItemCell>
      <ListItemCell style={{ justifyContent: 'flex-start' }}>
        <ListAvatar entity={props.test.athlete} large />
      </ListItemCell>
      <ListItemCell>
        <Metric
          style={{ alignItems: 'center' }}
          value={roundValue(
            props.test[props.metric.value].value,
            props.test[props.metric.value].roundingPrecision
          )}
          units={
            props.test[
              !isEmpty(props.metric)
                ? props.metric.value
                : (props.testType.entity as ITestType).defaultKey
            ].units
          }
        />
      </ListItemCell>
    </ListItem>
  );
};

const OrdinalContainer = styled.div``;
